import { render } from "./IconSpinner.vue?vue&type=template&id=4a606725&ts=true"
import script from "./IconSpinner.vue?vue&type=script&lang=ts"
export * from "./IconSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__